import { convertSimpleDateToDateTimeZulu, formatDateToPicker } from 'utils/formatDatesAndHours';
import { ChangeEvent } from 'react';

import './EditableDateField.scss';

interface IEditableDateFieldProps {
  disabled?: boolean;
  value?: string;
  onChange?: (newDate: string) => void;
}

export const EditableDateField = ({ value, disabled, onChange }: IEditableDateFieldProps) => {
  const handeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target as HTMLInputElement;
    const newDateTime = convertSimpleDateToDateTimeZulu(value, undefined);
    if (newDateTime !== 'Invalid DateTime') {
      onChange?.(newDateTime);
    }
  };
  return (
    <input
      disabled={disabled}
      className="editableDateField"
      type="date"
      value={value ? formatDateToPicker(value) : undefined}
      onChange={handeChange}
    />
  );
};
